import { render, staticRenderFns } from "./ReportDisputes.vue?vue&type=template&id=346ebdac&"
import script from "./ReportDisputes.vue?vue&type=script&lang=js&"
export * from "./ReportDisputes.vue?vue&type=script&lang=js&"
import style0 from "./ReportDisputes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports